import React from 'react';

import { RightSidebar } from "src/pages/_partials/Layout";
import { BundleInterface } from "src/store/community/bundlesSlice";
import RowInfo from "src/componets/RowInfo";
import OptionalLink from "../../../../componets/OptionalLink";

const _SidebarShow = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  const renderDetails = () => {
    if(!bundle) {
      return null;
    }

    function renderStoreName() {
      if(bundle?.store_name) {
        return <OptionalLink link={bundle.store_url}>{bundle.store_name}</OptionalLink>
      }
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={bundle.id} />
          <RowInfo left='Bundle Name' right={bundle.name} />
          <RowInfo left='Store Name' right={renderStoreName()} />
          <RowInfo left='Version' right={bundle.version} />
          <RowInfo left='Platform' right={bundle.platform} />
          <RowInfo left='Environment' right={bundle.prod ? 'production' : 'development'} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
